import React, { useState, useEffect } from 'react';
import { CheckCircle, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const names = [
  'Marc', 'Sophie', 'Pierre', 'Julie', 'Alexandre', 'Nathalie', 'Jean', 'Marie',
  'Patrick', 'Isabelle', 'François', 'Stéphanie', 'Martin', 'Caroline', 'André',
  'Chantal', 'Michel', 'Sylvie', 'Daniel', 'Lucie', 'Éric', 'Manon', 'Robert',
  'Josée', 'Alain', 'Lise', 'Yves', 'Diane', 'Claude', 'Hélène'
];

const cities = [
  'Montréal', 'Laval', 'Longueuil', 'Québec', 'Gatineau', 'Sherbrooke',
  'Trois-Rivières', 'Terrebonne', 'Saint-Jean', 'Brossard', 'Drummondville',
  'Saint-Jérôme', 'Granby', 'Blainville', 'Châteauguay', 'Repentigny',
  'Mascouche', 'Mirabel', 'Victoriaville', 'Rimouski', 'Verdun', 'Boucherville'
];

const vehiclesFr = ['une berline', 'un VUS', 'un camion', 'une auto'];
const vehiclesEn = ['a sedan', 'an SUV', 'a truck', 'a car'];

const timeAgoFr = ['il y a 2 minutes', 'il y a 5 minutes', 'il y a 8 minutes', 'il y a 12 minutes', 'il y a 15 minutes', 'il y a 20 minutes'];
const timeAgoEn = ['2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago', '20 minutes ago'];

const SocialProofPopup = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;

    const gen = () => {
      const name = names[Math.floor(Math.random() * names.length)];
      const city = cities[Math.floor(Math.random() * cities.length)];
      const vehicle = language === 'en'
        ? vehiclesEn[Math.floor(Math.random() * vehiclesEn.length)]
        : vehiclesFr[Math.floor(Math.random() * vehiclesFr.length)];
      const time = language === 'en'
        ? timeAgoEn[Math.floor(Math.random() * timeAgoEn.length)]
        : timeAgoFr[Math.floor(Math.random() * timeAgoFr.length)];

      const templates = language === 'en' ? [
        { text: `${name} from ${city} was just approved for ${vehicle}!`, sub: time },
        { text: `${name} from ${city} submitted an application`, sub: time },
        { text: `${name} from ${city} got pre-approved!`, sub: time },
      ] : [
        { text: `${name} de ${city} vient d'être approuvé(e) pour ${vehicle}!`, sub: time },
        { text: `${name} de ${city} a soumis une demande`, sub: time },
        { text: `${name} de ${city} a obtenu une pré-approbation!`, sub: time },
      ];

      return templates[Math.floor(Math.random() * templates.length)];
    };

    const initialDelay = setTimeout(() => {
      setNotification(gen());
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 20000);

    const interval = setInterval(() => {
      setNotification(gen());
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 45000);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [language, dismissed]);

  if (dismissed || !notification) return null;

  return (
    <div
      className={`fixed bottom-20 md:bottom-20 left-4 z-40 transition-all duration-500 ease-in-out hidden md:block ${
        visible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
      data-testid="social-proof-popup"
    >
      <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-4 max-w-xs relative">
        <button
          onClick={() => setDismissed(true)}
          className="absolute top-1 right-2 text-gray-400 hover:text-gray-600 text-xs"
          aria-label="Close"
        >
          x
        </button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
            <CheckCircle className="w-5 h-5 text-[#1a5c3b]" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900 leading-tight pr-4">{notification.text}</p>
            <div className="flex items-center gap-1 mt-1">
              <MapPin className="w-3 h-3 text-gray-400" />
              <span className="text-xs text-gray-500">{notification.sub}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProofPopup;
